module.exports = __webpack_public_path__ + "img/bacc.89c8890b.png";